import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Layouts
import { DashboardLayoutComponent }  from './layout/dashboard-layout/dashboard-layout.component';
import { SuperadminLayoutComponent } from './features/superadmin/superadmin-layout/superadmin-layout.component';

// Guards
import { AuthGuard }       from './core/guards/auth.guard';
import { SuperAdminGuard } from './core/guards/superadmin.guard';

// Landing

// Dashboard
import { DashboardComponent } from './features/dashboard/dashboard/dashboard.component';
import { LiveMapComponent }   from './features/dashboard/live-map/live-map.component';

// Users
import { InviteWorkerComponent } from './features/users/invite-worker/invite-worker/invite-worker.component';
import { WorkersListComponent }  from './features/users/invite-worker/workers-list/workers-list.component';

// Jobs
import { JobsListComponent }   from './features/jobs/jobs-list/jobs-list.component';
import { CreateJobComponent }  from './features/jobs/create-job/create-job.component';
import { JobLogsComponent }    from './features/jobs/job-logs/job-logs.component';
import { JobDetailsComponent } from './features/jobs/job-details/job-details.component';

// Reports
import { ReportsComponent } from './features/reports/reports.component';

// Company
import { CompanyProfileComponent } from './features/company/company-profile/company-profile.component';

// Pricing + Payment
import { PricingComponent }        from './features/pricing/pricing.component';
import { PaymentSuccessComponent } from './features/payment-success/payment-success.component';

// 404
import { NotFoundComponent } from './features/not-found/not-found.component';

// Superadmin
import { SuperadminDashboardComponent }     from './features/superadmin/superadmin-dashboard/superadmin-dashboard.component';
import { SuperadminCompaniesComponent }     from './features/superadmin/superadmin-companies/superadmin-companies.component';
import { SuperadminCompanyDetailComponent } from './features/superadmin/superadmin-company-detail/superadmin-company-detail.component';
import { SuperadminWorkersComponent }       from './features/superadmin/superadmin-workers/superadmin-workers.component';
import { SuperadminJobsComponent }          from './features/superadmin/superadmin-jobs/superadmin-jobs.component';
import { LandingComponent } from './features/landing/landing/landing.component';
import { AiInsightsPanelComponent } from './features/ai-insights/ai-insights-panel/ai-insights-panel/ai-insights-panel.component';
import { PrivacyPolicyComponent } from './features/privacy-policy/privacy-policy.component';
import { ContactComponent } from './features/contact/contact.component';

const routes: Routes = [

  // 1 — Auth lazy loaded
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then(m => m.AuthModule)
  },

  // 2 — Root & home → Landing page
  { path: '',     component: LandingComponent, pathMatch: 'full' },
  { path: 'home', component: LandingComponent },
  {
  path:      'privacy-policy',
  component: PrivacyPolicyComponent
},
{
  path:      'contact',
  component: ContactComponent
},

  // 3 — Standalone pages
  { path: '404',             component: NotFoundComponent },
  { path: 'pricing',         component: PricingComponent },
  { path: 'payment/success', component: PaymentSuccessComponent },

  // 4 — Super Admin layout
  {
    path: 'superadmin',
    component: SuperadminLayoutComponent,
    canActivate: [SuperAdminGuard],
    children: [
      { path: 'dashboard',     component: SuperadminDashboardComponent },
      { path: 'companies',     component: SuperadminCompaniesComponent },
      { path: 'companies/:id', component: SuperadminCompanyDetailComponent },
      { path: 'workers',       component: SuperadminWorkersComponent },
      { path: 'jobs',          component: SuperadminJobsComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },

  // 5 — Regular admin layout
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard',       component: DashboardComponent },
      { path: 'workers',         component: WorkersListComponent },
      { path: 'invite-worker',   component: InviteWorkerComponent },
      { path: 'jobs',            component: JobsListComponent },
      { path: 'jobs/:id',        component: JobDetailsComponent },
      { path: 'jobs/:id/logs',   component: JobLogsComponent },
      { path: 'create-job',      component: CreateJobComponent },
      { path: 'company-profile', component: CompanyProfileComponent },
      { path: 'ai-insights', component: AiInsightsPanelComponent },
      

      // ✅ All visible — exports blocked inside each component by plan check
      { path: 'live-map', component: LiveMapComponent },
      { path: 'reports',  component: ReportsComponent },

      // Safety module — all plans can view, Enterprise only can export
      {
        path: 'safety',
        loadChildren: () =>
          import('./features/safety/safety.module').then(m => m.SafetyModule)
      },
    ]
  },

  // 6 — Wildcard
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}